import { useTranslation } from '@framework/i18n';
import { Alert, AlertProps } from 'antd';
import * as React from 'react';
import { OnPageAlertContainer } from './OnPageAlertContainer';

export interface IAlertErrorBodyProps extends AlertProps {}

export function AlertErrorBody(props: IAlertErrorBodyProps) {
  const { message, ...rest } = props;
  const { t } = useTranslation();

  return (
    <OnPageAlertContainer>
      <Alert
        showIcon
        type="error"
        message={
          message ??
          t(
            'alert.alert-error-body.message',
            'Sì è verificato un errore nella richiesta.',
          )
        }
        {...rest}
      />
    </OnPageAlertContainer>
  );
}
